import type { TargetOrganization } from '@/session/identity';
import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { IntegrationAllowance } from '@/types/integration';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  target: TargetOrganization;
  data: Partial<IntegrationAllowance>[];
};

/** The API applies every row or none, and returns no rows. */
type Response = null;

export const bulkUpdateIntegrationAllowances = async (
  { target, data }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const stampedData = data.map((row) => ({ ...row, organization_id: target.id }));
    const response = await scopedApi(GLOBAL_SCOPE).put<EndpointResponse<Response>>('integration_allowance/bulk', stampedData, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
